import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, NavigationExtras, ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/Services/dataservice.service";
import { SessionService } from "../service/session.service";
import { ApiService } from "../service/apiservice.service";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { AuthModalService } from "src/app/Services/auth-modal.service";

import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
  FormControlName,
  ValidatorFn,
  AbstractControl,
  FormGroupDirective,
  NgForm,
} from "@angular/forms";
import { UserserviceService } from "src/app/Services/userservice.service";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/Services/auth.service";
import { ErrorStateMatcher } from "@angular/material/core";
import { TokenService } from "src/app/Services/token.service";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { PermissionsService } from "src/app/Services/permissions.service";
import { PasskeyService } from "src/app/Services/passkey.service";
import { PasskeyPromptService } from "src/app/Services/passkey-prompt.service";
import { PasskeySetupDialogComponent } from "src/app/pages/passkey-setup-dialog/passkey-setup-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { OrgContextService } from "src/app/Services/org-context.service";
import { of } from "rxjs";
import { catchError, finalize, timeout } from "rxjs/operators";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: UntypedFormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  showNotificationCount: boolean;
  notificationCount: number;
  fieldTextType: boolean;
  profilePicture: string;
  userDisplayName: any;
  userData: any;
  showDefaultImage: boolean;
  phone: any;
  info: any;
  website: any;
  uname: any;
  name: any;
  noResultReturned: boolean;
  matcher = new MyErrorStateMatcher();
  showPassword: boolean = false;
  returnUrl: string = "/";
  permissionsList: any;
  isSubmitting: boolean = false;
  passkeySupported: boolean = false;
  isPasskeySubmitting: boolean = false;
  passkeyError: string = "";
  passkeyHintExpanded: boolean = false;
  /** Yahoo-style: email → check passkeys → password OR passkey */
  loginStep: "email" | "password" | "passkey" = "email";
  accountHasPasskeys = false;
  isCheckingAccount = false;
  /** Signed in; waiting for account type (Public / Organization) before navigating. */
  isResolvingAccountType = false;
  stepError = "";
  private passkeyAutofillStarted = false;
  
  @Output() closeModal = new EventEmitter<void>();

  constructor(
    private data: DataService,
    //public translate: TranslateService,
    private flowServiceService: FlowServiceService,
    private permissionsService: PermissionsService,
    private session: SessionService,
    public route: Router,
    private apiService: ApiService,
    private http: HttpClient,
    private activateroute: ActivatedRoute,
    private router: Router,
    public formbuilder: UntypedFormBuilder,
    private userserviceService: UserserviceService,
    private toastr: ToastrService,
    private authService: AuthService,
    private tokenService: TokenService,
    private eventService: EventEmitterService,
    public authModalService: AuthModalService,
    private passkeyService: PasskeyService,
    private passkeyPromptService: PasskeyPromptService,
    private dialog: MatDialog,
    private orgContextService: OrgContextService
  ) {}

  loginForm = new UntypedFormGroup({
    EmailAddress: new UntypedFormControl("", [
      Validators.required,
      Validators.email,
    ]),
    Password: new UntypedFormControl("", Validators.required),
  });

  PersonModel: any = [];
  /** Kept for legacy call sites; prefer form controls. */
  get EmailAddress(): string {
    return (this.loginForm?.get("EmailAddress")?.value || "").toString().trim();
  }
  set EmailAddress(value: string) {
    this.loginForm?.get("EmailAddress")?.setValue(value || "");
  }
  get Password(): string {
    return (this.loginForm?.get("Password")?.value || "").toString();
  }
  set Password(value: string) {
    this.loginForm?.get("Password")?.setValue(value || "");
  }

  get emailValue(): string {
    return this.EmailAddress;
  }

  @ViewChild("email", { static: false }) email: ElementRef;
  @ViewChild("password", { static: false }) password: ElementRef;
  alertCtrl: any;
  dataService: any;

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit() {
    this.passkeySupported = this.passkeyService.isSupported();
    this.returnUrl =
      this.activateroute.snapshot.queryParamMap.get("returnUrl") || "/";
    localStorage.removeItem("Permissions");
    this.loginForm = this.formbuilder.group({
      Password: new UntypedFormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),

      EmailAddress: new UntypedFormControl("", [
        Validators.required,
        Validators.email,
      ]),
    });

    this.getProfileUser();
    // Get return URL from AuthModalService (stored when modal was opened)
    const storedReturnUrl = this.authModalService.getReturnUrl();
    if (storedReturnUrl && storedReturnUrl !== '/') {
      this.returnUrl = storedReturnUrl;
    } else {
      this.returnUrl = localStorage.getItem("returnUrl") || "/";
    }
    console.log(this.returnUrl);
    // Conditional UI waits until email is known (after Next).
  }

  get isEmailValid(): boolean {
    const ctrl = this.loginForm?.get("EmailAddress");
    return !!(ctrl && ctrl.valid && this.EmailAddress);
  }

  get isPasswordValid(): boolean {
    const ctrl = this.loginForm?.get("Password");
    return !!(ctrl && ctrl.valid && this.Password);
  }

  get loginStepTitle(): string {
    switch (this.loginStep) {
      case "password":
        return "Enter password";
      case "passkey":
        return "Sign in with Passkey";
      default:
        return "Sign In to continue";
    }
  }

  togglePasskeyHint(): void {
    this.passkeyHintExpanded = !this.passkeyHintExpanded;
  }

  onPrimarySubmit(): void {
    if (this.loginStep === "email") {
      this.goToNextStep();
      return;
    }
    if (this.loginStep === "password") {
      this.signIn();
    }
  }

  async goToNextStep(): Promise<void> {
    this.stepError = "";
    this.passkeyError = "";
    this.loginForm.get("EmailAddress")?.markAsTouched();
    if (!this.isEmailValid) {
      return;
    }

    const email = this.EmailAddress.toLowerCase();
    this.EmailAddress = email;
    this.loginForm.get("Password")?.reset("");
    this.passkeyHintExpanded = false;
    this.accountHasPasskeys = false;
    this.isCheckingAccount = true;

    try {
      // Yahoo-style: ask the server whether this email has a Passkey.
      this.accountHasPasskeys =
        this.passkeySupported &&
        (await this.passkeyService.hasPasskeys(email));

      if (this.accountHasPasskeys) {
        this.goToPasskeyStep();
      } else {
        this.goToPasswordStep();
      }
    } catch {
      // On check failure, fall back to password (always works).
      this.accountHasPasskeys = false;
      this.goToPasswordStep();
    } finally {
      this.isCheckingAccount = false;
    }
  }

  goToPasswordStep(): void {
    this.passkeyError = "";
    this.passkeyHintExpanded = false;
    this.passkeyService.abortPendingCeremony();
    this.loginForm.get("Password")?.reset("");
    this.loginStep = "password";
  }

  goToPasskeyStep(): void {
    if (!this.passkeySupported || !this.accountHasPasskeys) {
      this.goToPasswordStep();
      return;
    }
    this.passkeyError = "";
    this.passkeyHintExpanded = false;
    this.loginStep = "passkey";
    this.startPasskeyConditionalUi();
  }

  backToEmailStep(): void {
    this.loginStep = "email";
    this.passkeyError = "";
    this.stepError = "";
    this.passkeyHintExpanded = false;
    this.accountHasPasskeys = false;
    this.passkeyService.abortPendingCeremony();
    this.passkeyAutofillStarted = false;
    this.loginForm.get("Password")?.reset("");
  }

  private async startPasskeyConditionalUi(): Promise<void> {
    if (!this.passkeySupported || this.passkeyAutofillStarted) {
      return;
    }
    this.passkeyAutofillStarted = true;
    try {
      const data = await this.passkeyService.authenticateWithAutofill(
        this.EmailAddress || undefined
      );
      if (data) {
        this.handleLoginSuccess(data, { fromPasskey: true });
      }
    } catch {
      // Silent: autofill cancelled / unsupported / no passkey — keep password form usable.
    }
  }
  // togglePasswordVisibility(): void {
  //   this.showPassword = !this.showPassword;
  // }

  // tslint:disable-next-line:variable-name
  equalto(field_name: string | number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const input = control.value;

      const isValid = control.root.value[field_name] === input;
      if (!isValid) {
        return { equalTo: { isValid } };
      } else {
        return null;
      }
    };
  }

  resolved(captchaResponse: string) {}

  toggle() {
    this.fieldTextType = !this.fieldTextType;
  }

  showToast() {
    this.toastr.success("Sign In Successful");
  }

  showToastForLogout() {
    this.toastr.success("Logout Successful", "title");
  }

  signIn() {
    if (
      this.isSubmitting ||
      this.isResolvingAccountType ||
      !this.isEmailValid ||
      !this.isPasswordValid
    ) {
      this.loginForm.get("Password")?.markAsTouched();
      return;
    }
    this.isSubmitting = true;
    this.passkeyError = "";
    const pushNotificationToken = localStorage.getItem("pushNotificationToken");

    const loginModel = {
      userName: this.EmailAddress,
      password: this.Password,
      WebPushNotificationToken: pushNotificationToken,
    };
    this.userserviceService
      .login(loginModel)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(
      (data) => {
        console.log(data);
        this.handleLoginSuccess(data, { fromPasskey: false });
      },
      (error) => {
        this.toastr.error("Invalid Email or Password");
        //
        this.noResultReturned = false;
        // Modal stays open on error
      }
    );
    //   },
    //   (err: any) => {

    //   }
    // );
  }

  async signInWithPasskey() {
    if (
      !this.passkeySupported ||
      this.isPasskeySubmitting ||
      this.isSubmitting ||
      this.isResolvingAccountType
    ) {
      return;
    }
    this.isPasskeySubmitting = true;
    this.passkeyError = "";
    // Stop Conditional UI so it does not abort/race the button ceremony.
    this.passkeyService.abortPendingCeremony();
    try {
      const email = this.isEmailValid
        ? this.EmailAddress.toLowerCase()
        : undefined;
      const data = await this.passkeyService.authenticate(email);
      this.handleLoginSuccess(data, { fromPasskey: true });
    } catch (error) {
      this.passkeyError = this.passkeyService.mapError(error);
      this.passkeyHintExpanded = true;
      this.toastr.error(this.passkeyError);
      this.noResultReturned = false;
    } finally {
      this.isPasskeySubmitting = false;
    }
  }

  private handleLoginSuccess(
    data: any,
    options: { fromPasskey?: boolean } = {}
  ) {
    if (data != null && data.userModel != null) {
      if (data.userModel.isActive) {
        if (data.userModel.profilePicUrl || data.userModel.ProfilePicUrl) {
          data.userModel.profilePicUrl =
            data.userModel.profilePicUrl || data.userModel.ProfilePicUrl;
        }
        localStorage.setItem(
          "LoggedInUser",
          JSON.stringify(data.userModel)
        );
        localStorage.setItem("userObjWithTokens", JSON.stringify(data));
        // Save tokens BEFORE emitting the event to ensure they're available when event handlers run
        this.tokenService.saveToken(data.accessToken);
        this.tokenService.saveRefreshToken(data.refreshToken);
        localStorage.setItem("isLogin", "Yes");
        // Drop any previous session's account scope so the account type is
        // resolved fresh for this user (remembered choice or org default).
        this.orgContextService.clear();
        this.data.changeMessagebool(true);
        this.eventService.setLoggedInUserProperty(true);
        this.showToast();
        this.GetPermissionsData(data.userModel);

        this.checkTransferOwnershipDetails(data.userModel);
        var flowData = JSON.parse(localStorage.getItem("checkoutFlow"));

        const finish = () => {
          this.closeModal.emit();
          if (!options.fromPasskey) {
            this.maybeOfferPasskeySetup(data.userModel);
          }
        };

        const navigate = () => {
          this.isResolvingAccountType = false;
          if (flowData != null) {
            flowData.Type == "Bundle"
              ? this.router.navigate(["/view-guide-pack/" + flowData.rowKey]).then(finish)
              : this.router.navigate([
                  `/guide/${this.generateUrlSlug(flowData.title)}/${
                    flowData.rowKey
                  }`,
                ]).then(finish);
          } else {
            // Clear return URL from AuthModalService after successful sign in
            this.authModalService.clearReturnUrl();
            this.router.navigateByUrl(this.returnUrl).then(finish);
          }
        };

        // Resolve account type before navigating so the landing page and shell
        // render Public vs Organization features from the start.
        this.isResolvingAccountType = true;
        this.orgContextService
          .load()
          .pipe(
            timeout(10000),
            catchError(() => of(null))
          )
          .subscribe({ complete: navigate });
      } else {
        this.toastr.error(
          "Account is not activated. Please activate account using the code sent to your email account"
        );
        localStorage.setItem(
          "activateaccountemailaddress",
          data.userModel.emailAddress || this.EmailAddress
        );
        this.authModalService.openModal('activateaccount');
        //  this.router.navigate(["/activateaccount"]);
      }
    } else {
      this.noResultReturned = false;
      this.toastr.error("Sign In Failed");
    }
  }

  private async maybeOfferPasskeySetup(userModel: any): Promise<void> {
    const email =
      userModel?.emailAddress ||
      userModel?.EmailAddress ||
      this.EmailAddress ||
      "";
    try {
      const shouldPrompt = await this.passkeyPromptService.shouldAutoPrompt(
        email
      );
      if (!shouldPrompt) {
        return;
      }
      this.dialog.open(PasskeySetupDialogComponent, {
        panelClass: "dialoguebox",
        autoFocus: false,
        disableClose: false,
        backdropClass: "non-transparent-backdrop",
        data: { email },
      });
    } catch {
      // Never block login UX if prompt logic fails.
    }
  }

  GetPermissionsData(userData): void {
    this.permissionsService.refresh(userData).subscribe((map) => {
      this.premissionToActions = map;
      try {
        this.permissionsList = JSON.parse(
          localStorage.getItem("Permissions") || "[]"
        );
      } catch {
        this.permissionsList = [];
      }
    });
  }

  premissionToActions: { [feature: string]: { [action: string]: boolean } } =
    {};

  createFlow() {
    this.router.navigate(["/create-guide"]);
  }

  getProfileUser(): void {
    if (this.userData != null) {
      this.showNotificationCount = true;
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
        localStorage.setItem("LoggedInUser", JSON.stringify(data.userModel));
      });
    }
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
    this.showToastForLogout();
    this.authService.logout();
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";

    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  /**
   * Check transfer ownership details and show toast message if there are any transfers
   */
  checkTransferOwnershipDetails(userData): void {
    try {
      // const userData = JSON.parse(localStorage.getItem("LoggedInUser") || "{}");

      if (userData && userData.partitionKey) {
        console.log(
          "Checking transfer ownership details for user:",
          userData.partitionKey
        );

        const flowQueryModel = { userEmail: userData.partitionKey };

        this.flowServiceService
          .getUserTransferOwnershipDetails(
            flowQueryModel,
            userData.partitionKey
          )
          .subscribe((response: any) => {
            console.log("Transfer ownership response:", response);

            if (response && Array.isArray(response) && response.length > 0) {
              // Filter transfers based on newOwnerEmail and oldOwnerEmail with userData.partitionKey
              // Only count requests that are NOT rejected or accepted (i.e., only pending requests)
              // Statuses to EXCLUDE: "Approved", "Rejected", "Cancelled", "ReworkRejected"
              // Statuses to INCLUDE: "Pending", "ReworkRequested", "ReworkAccepted"
              const incomingTransfers = response.filter(
                (item: any) =>
                  item.newOwnerEmail === userData.partitionKey &&
                  item.requestStatus !== "Approved" &&
                  item.requestStatus !== "Rejected" &&
                  item.requestStatus !== "Cancelled" &&
                  item.requestStatus !== "ReworkRejected"
              );

              const outgoingTransfers = response.filter(
                (item: any) =>
                  item.oldOwnerEmail === userData.partitionKey &&
                  item.requestStatus !== "Approved" &&
                  item.requestStatus !== "Rejected" &&
                  item.requestStatus !== "Cancelled" &&
                  item.requestStatus !== "ReworkRejected"
              );

              // Log detailed status breakdown for debugging
              const statusBreakdown = response.reduce((acc: any, item: any) => {
                const status = item.requestStatus || "Unknown";
                acc[status] = (acc[status] || 0) + 1;
                return acc;
              }, {});

              console.log(
                "Transfer ownership status breakdown:",
                statusBreakdown
              );
              console.log("Total transfer requests found:", response.length);
              console.log(
                "Pending incoming transfers:",
                incomingTransfers.length,
                "Pending outgoing transfers:",
                outgoingTransfers.length
              );

              // Log sample of filtered requests for debugging
              if (incomingTransfers.length > 0) {
                console.log("Sample incoming transfer:", incomingTransfers[0]);
              }
              if (outgoingTransfers.length > 0) {
                console.log("Sample outgoing transfer:", outgoingTransfers[0]);
              }

              if (incomingTransfers.length > 0) {
                this.showIncomingTransferOwnershipToast(
                  incomingTransfers.length
                );
              }

              if (outgoingTransfers.length > 0) {
                this.showOutgoingTransferOwnershipToast(
                  outgoingTransfers.length
                );
              }

              if (
                incomingTransfers.length === 0 &&
                outgoingTransfers.length === 0
              ) {
                console.log("No pending transfer requests found for user");
              }
            } else {
              console.log("No transfer ownership data found");
            }
          });
      } else {
        console.log(
          "No user data or partitionKey found, skipping transfer ownership check"
        );
      }
    } catch (error) {
      console.error("Error in checkTransferOwnershipDetails:", error);
    }
  }

  /**
   * Build the message for transfer ownership toast
   */
  private formatCountLabel(count: number, label: string): string {
    return `${count} ${label}${count === 1 ? "" : "s"}`;
  }

  /**
   * Show persistent toast message for transfer ownership
   */
  private showIncomingTransferOwnershipToast(incomingCount: number): void {
    const message = this.formatCountLabel(incomingCount, "incoming request");
    const html = `<span class="incoming-link" style="color: #007bff; text-decoration: underline; cursor: pointer;">${message}</span>`;
    const toastRef = this.toastr.info(html, "Incoming Ownership", {
      timeOut: 0,
      extendedTimeOut: 0,
      closeButton: true,
      progressBar: false,
      enableHtml: true,
      tapToDismiss: false,
    });

    setTimeout(() => {
      const incomingLink = document.querySelector(".incoming-link");
      if (incomingLink) {
        incomingLink.addEventListener("click", () => {
          this.navigateToTransferApprovals("incoming");
        });
      }
    }, 100);
  }

  private showOutgoingTransferOwnershipToast(outgoingCount: number): void {
    const message = this.formatCountLabel(outgoingCount, "outgoing request");
    const html = `<span class="outgoing-link" style="color: #007bff; text-decoration: underline; cursor: pointer;">${message}</span>`;
    const toastRef = this.toastr.info(html, "Outgoing Ownership", {
      timeOut: 0,
      extendedTimeOut: 0,
      closeButton: true,
      progressBar: false,
      enableHtml: true,
      tapToDismiss: false,
    });

    setTimeout(() => {
      const outgoingLink = document.querySelector(".outgoing-link");
      if (outgoingLink) {
        outgoingLink.addEventListener("click", () => {
          this.navigateToTransferApprovals("outgoing");
        });
      }
    }, 100);
  }

  /**
   * Navigate to transfer approvals page
   */
  // private navigateToTransferApprovals(mode?: "incoming" | "outgoing"): void {
  //   try {
  //     console.log("Navigating to transfer approvals page...", mode);
  //     const base = "/user-dashboard/tranfer-approvals";
  //     const target = mode ? `${base}/${mode}` : base;
  //     this.router.navigate([target]).then(() => {
  //       console.log("Successfully navigated to transfer approvals page");
  //       // Remove the notification after successful navigation
  //       this.cleanupTransferOwnershipNotification();
  //     }).catch((error) => {
  //       console.error("Error navigating to transfer approvals page:", error);
  //       this.toastr.error("Unable to navigate to transfer approvals page");
  //     });
  //   } catch (error) {
  //     console.error("Error navigating to transfer approvals:", error);
  //   }
  // }

  private navigateToTransferApprovals(mode?: "incoming" | "outgoing"): void {
    try {
      console.log("Navigating to transfer approvals page...", mode);

      let target: string;

      if (mode === "incoming") {
        target = "/user-dashboard/incoming-tranfer-approvals"; // 👈 different route
      } else if (mode === "outgoing") {
        target = "/user-dashboard/outgoing-tranfer-approvals"; // 👈 different route
      }

      this.router
        .navigate([target])
        .then(() => {
          console.log("Successfully navigated to", target);
          this.cleanupTransferOwnershipNotification();
        })
        .catch((error) => {
          console.error("Error navigating to", target, error);
          this.toastr.error("Unable to navigate to transfer approvals page");
        });
    } catch (error) {
      console.error("Error navigating to transfer approvals:", error);
    }
  }

  /**
   * Check if a route exists in the router configuration
   */
  private checkRouteExists(routePath: string): boolean {
    try {
      // Get all routes from the router configuration
      const routes = this.router.config;
      return this.findRoute(routes, routePath);
    } catch (error) {
      console.warn("Could not verify route existence:", error);
      return true; // Assume route exists if we can't verify
    }
  }

  /**
   * Recursively search for a route in the router configuration
   */
  private findRoute(routes: any[], targetPath: string): boolean {
    for (const route of routes) {
      if (route.path === targetPath || route.path === targetPath.substring(1)) {
        return true;
      }
      if (route.children && this.findRoute(route.children, targetPath)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Remove existing transfer ownership notification
   */
  private removeExistingTransferOwnershipToast(): void {
    // Clear any existing toastr notifications
    this.toastr.clear();

    localStorage.removeItem("activeTransferOwnershipNotification");
  }

  /**
   * Add styles for transfer ownership notification
   */
  private addTransferOwnershipNotificationStyles(): void {
    // Method removed - no longer needed with toastr implementation
  }

  /**
   * Clean up transfer ownership notification
   */
  public cleanupTransferOwnershipNotification(): void {
    this.removeExistingTransferOwnershipToast();
  }

  /**
   * Check if there's an active transfer ownership notification and restore it
   */
  public restoreTransferOwnershipNotificationIfNeeded(): void {
    const activeNotificationId = localStorage.getItem(
      "activeTransferOwnershipNotification"
    );
    if (activeNotificationId === "toastr") {
      // For toastr notifications, we don't need to restore since they're managed by toastr
      // Just clean up the storage if needed
      localStorage.removeItem("activeTransferOwnershipNotification");
    }
  }

  /**
   * Public method to manually trigger transfer ownership check
   */
  // public triggerTransferOwnershipCheck(): void {
  //   this.checkTransferOwnershipDetails();
  // }

  /**
   * Check if there's an active transfer ownership notification
   */
  public hasActiveTransferOwnershipNotification(): boolean {
    // Check for toastr notification
    const activeNotification = localStorage.getItem(
      "activeTransferOwnershipNotification"
    );
    return activeNotification === "toastr";
  }
}
